import thor from '@sl/thor/dist/thor';

export default thor;
